import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { Language } from 'app/model/constant';

@Pipe({
  name: 'fullyear',
  pure: false
})
export class FullyearPipe implements PipeTransform {

  constructor(private appConfigService: AppConfigService) { }

  transform(value: any, args?: any): any {
    const lang = this.appConfigService.getLanguage();
    switch (lang) {
      case Language.th:
        return parseInt(value) + 543;
      case Language.en:
        return value;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/fullyear.pipe.ts